import { render, staticRenderFns } from "./DownloadJobFilesTable.vue?vue&type=template&id=37e1fbef&scoped=true"
import script from "./DownloadJobFilesTable.vue?vue&type=script&lang=ts"
export * from "./DownloadJobFilesTable.vue?vue&type=script&lang=ts"
import style0 from "./DownloadJobFilesTable.vue?vue&type=style&index=0&id=37e1fbef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e1fbef",
  null
  
)

export default component.exports